import { formatDuration } from "@/lib/utils";
import {
  formatDurationForTransport,
  getTraceTransportType,
} from "@/utils/trace-utils";
import type { EnhancedTrace } from "./types";

interface DurationCellProps {
  duration: number;
  maxDuration: number;
  trace?: EnhancedTrace;
}

export function DurationCell({
  duration,
  maxDuration,
  trace,
}: DurationCellProps) {
  const widthPercentage = maxDuration > 0 ? (duration / maxDuration) * 100 : 0;

  // Use transport-aware formatting if trace is provided
  const formattedDuration = trace
    ? formatDurationForTransport(duration, getTraceTransportType(trace))
    : formatDuration(duration);

  return (
    <div className="@container flex items-center gap-2 min-w-0 w-full h-full">
      {/* Duration text - always visible */}
      <div className="text-xs text-muted-foreground font-mono flex-1 text-center @[70px]:text-right @[70px]:flex-none @[70px]:w-10 truncate">
        {formattedDuration}
      </div>
      {/* Duration bar - show when container >= 70px wide */}
      <div className="flex-1 relative h-3 min-w-[20px] hidden @[70px]:block">
        <div className="@[70px]:opacity-100 opacity-0 p-1 w-full h-full bg-muted rounded-full overflow-hidden transition-opacity duration-200 flex">
          <div
            className="flex-shrink-0 bg-primary transition-all duration-300 rounded-full"
            style={{
              width: `${widthPercentage}%`,
              minWidth: duration > 0 ? "2px" : "0px",
            }}
          />
        </div>
      </div>
    </div>
  );
}
